import EmptyChart from './emptyChart.component';

export default EmptyChart;